import moment from 'moment';

import { lang } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';

// "5 years" / "1 year". If no valid value, return the raw value (same as before).
export const getExperienceLabel = (doctor) => {
  const years = doctor.yearOfStarting
    ? moment().year() - doctor.yearOfStarting + 1
    : doctor.training;
  if (!(years > 0)) return years;
  return lang.t(years > 1 ? LANG_CONST.amount_years : LANG_CONST.amount_year, {
    amount: years
  });
};

// Returns a handler for MCDatePicker `onClassNamesOfCell`.
// Adds the "available" class to days that have a slot.
export const getAvailableDayHandler = (slotsMonth = []) => (day, classNames) => {
  const start = day.clone().startOf('day');
  const end = day.clone().endOf('day');
  if (slotsMonth.some((s) => s.startDate >= start && s.startDate <= end)) {
    classNames.push('available');
  }
};

// "Hospital name_branch" -> "Hospital name"
export const getHospitalLabel = (hospital) => hospital?.split('_')[0];
